import React from 'react'
import { Redirect } from 'react-router-dom'

class UserRedirect extends React.PureComponent {
  render() {
    if (this.props.location && this.props.location.search) {
      const search = this.props.location.search.replace('?user=', '').replace('?test=','')
      return <Redirect to={{ pathname: `/tests`, state: {user: search} }} />
    } else {
      return ''
    }
  }
}

export default UserRedirect



// WEBPACK FOOTER //
// ./src/js/components/UserRedirect.js